export default __webpack_public_path__ + "static/bny_mobile-1219ba3821d842557dbca817580f70cd.png";